import type { ApiResponse, OccupationSearchItem, OccupationDetail, CalibrateRequest, CalibrateResponse, CompareResponse } from "../types";

const API_BASE = "/api";

async function request<T>(path: string, options?: RequestInit): Promise<ApiResponse<T>> {
  try {
    const res = await fetch(`${API_BASE}${path}`, {
      headers: { "Content-Type": "application/json" },
      ...options,
    });
    if (!res.ok) {
      return { success: false, data: null, error: `HTTP ${res.status}`, meta: null };
    }
    return res.json();
  } catch {
    return { success: false, data: null, error: "无法连接服务器，请确认后端已启动", meta: null };
  }
}

export function searchOccupations(q: string, category?: string, limit = 10) {
  const params = new URLSearchParams({ q, limit: String(limit) });
  if (category) params.set("category", category);
  return request<OccupationSearchItem[]>(`/occupations?${params}`);
}

export function getOccupationDetail(id: number) {
  return request<OccupationDetail>(`/occupations/${id}/detail`);
}

export function calibrateAssessment(body: CalibrateRequest) {
  return request<CalibrateResponse>("/assessment/calibrate", {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function compareAssessment(body: CalibrateRequest) {
  return request<CompareResponse>("/assessment/compare", {
    method: "POST",
    body: JSON.stringify(body),
  });
}
